import { DashboardState } from "types/Dashboard";
import { DashboardConstants } from "../constants/constants";
import moment from "moment";
import { ReducersInterfaceAction } from "types/Reducers";
import { initialDashboardState } from "store/initialStates";

export const dashboardReducer = (
  state = initialDashboardState,
  action: ReducersInterfaceAction,
): DashboardState => {
  switch (action.type) {
    case DashboardConstants.DASHBOARD_DATE_LOADING:
      return {
        ...state,
        dashBoardDateLoading: true,
      };
    case DashboardConstants.DASHBOARD_DATE_SUCCESS:
      return {
        ...state,
        dashBoardDate: action.payload,
        dashBoardDateLoading: false,
      };
    case DashboardConstants.DASHBOARD_DATE_ERROR:
      return {
        ...state,
        dashBoardDateLoading: false,
      };
    case DashboardConstants.DASHBOARD_MODAL_STATE:
      return {
        ...state,
        dashboardModalState: !state.dashboardModalState,
      };
    case DashboardConstants.DASHBOARD_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case DashboardConstants.DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        dashboardDataList: action.payload.results,
        dashboardDataListCount: action.payload.count,
      };
    case DashboardConstants.DASHBOARD_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case DashboardConstants.DASHBOARD_UPDATE_SETTINGS:
      return {
        ...state,
        dashboardSettings: { ...state.dashboardSettings, ...action.payload },
      };
    case DashboardConstants.DASHBOARD_CHANGE_ROWS_PER_PAGE:
      return {
        ...state,
        dashboardTableRowsPerPage: action.payload,
      };
    case DashboardConstants.DASHBOARD_INITIALIZE_LABEL_DATE_TYPE:
      return {
        ...state,
        dashboardSettings: {
          ...state.dashboardSettings,
          dateFilters: {
            week: `${moment().format("yyyy")}-W${moment().format("W")}`,
            month: `${moment().format("yyyy")}-${moment().format("MM")}`,
            date: moment().format("yyyy-MM-DD"),
            year: moment().format("yyyy"),
            startDate: `${moment().format("yyyy")}-W${moment().format("W")}`,
            endDate: `${moment().format("yyyy")}-W${moment().format("W")}`,
          },
          rejectedDaFilters: {
            driver: null,
          },
        },
      };
    case DashboardConstants.DASHBOARD_UPDATE_STATIONS_FILTER:
      return {
        ...state,
        dashboardSettings: {
          ...state.dashboardSettings,
          stations: action.payload,
        },
      };
    case DashboardConstants.DASHBOARD_BLOCK_MESSAGES_SUCCESS:
      return {
        ...state,
        dashboardDataList: action.payload,
        dashboardTableRowsPerPage: 100,
      };
    default:
      return state;
  }
};
